const rootKey = '/assessment';

export const assessmentCreate = () => {
  return `${rootKey}/create`;
};
